<!--
 * @Description  : 乘车人信息卡片
-->
<template minapp='mpx' xlang='wxml'>
  <view class="footer-content" wx:class="{{{'scramble-footer': isFromScramble}}}" wx:if="{{!isDetailShow && (changeTip || !licenseCheckedDefault && reminders != null)}}">
    <view wx:if="{{changeTip}}" class="change-tip">{{ changeTip }}</view>
    <block wx:elif="{{!licenseCheckedDefault && reminders != null}}">
      <view bindtap="licenseClick" wx:style="padding-top:{{paddingTop}};">
        <es-checkbox
          label-position="right"
          custom-class="custom-class"
          name="1"
          value="{{licenseAgreementSelected}}"
          shap="square"
          icon-style="{{checkboxIconWrapStyle}}"
          useIconSlot
        >
          <es-icon
            slot="icon"
            size="8"
            name="check-filled"
            wx:style="{{checkboxIconStyle}}"
          />
        </es-checkbox>
      </view>

      <view>
        <view
          class="protocol protocol-text"
          wx:class="{{{'scramble-text': isFromScramble, 'text-color': licenseAgreementSelected}}}"
          bindtap="licenseClick"
          >{{ reminders != null ? reminders.purchase_service : '' }}</view
        >
        <view
          class="protocol protocol-url"
          wx:class="{{{'scramble-url': isFromScramble, 'url-color': !licenseAgreementSelected}}}"
          bindtap="jumpToH5(item, index)"
          wx:for="{{purchaseList}}"
        >
          《{{ item.name }}》
        </view>
      </view>
    </block>
  </view>
  <pay-bottom-bar
    canPay="{{canPay}}"
    isMakeOrder
    showDealAlert="{{isDetailShow}}"
    totalFeeInfo="{{totalFeeInfo}}"
    payType="{{1}}"
    isFromScramble="{{isFromScramble}}"
    bind:pay="submitOrder"
    bind:scramblePay="submitScrambleOrder"
    bindsubmit="submitOrder"
    bind:click="changeDetail"
    studentLength="{{studentLength}}"
    isExemption="{{isExemption}}"
  />
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from '@/common/jump'

  createComponent({
    props: {
      licenseAgreementSelected: Boolean,
      licenseCheckedDefault: {
        type: Boolean,
        value: false
      },
      reminders: Object,
      purchaseList: Array,
      changeTip: String,
      isDetailShow: Boolean,
      totalFeeInfo: Array,
      canPay: Boolean,
      isFromScramble: Boolean,
      studentLength: Number,
      isExemption: Number,
    },
    data() {
      return {
        checkboxIconWrapStyle: {
          'border-radius': '4px',
          'align-self': 'normal',
        },
        checkboxIconStyle: {
          width: '16px',
        },
      }
    },
    computed: {
      paddingTop() {
        if (__mpx_mode__ !== 'web') {
          return '2px'
        } else {
          return '5px'
        }
      },
    },
    methods: {
      jumpToH5(item, index) {
        if (item.name === '铁路互联网购票须知') {
          innerRouter.push(pagePath().ICKETPURCHASENOTICE)
        } else {
          innerRouter.goTo(item.url)
        }
      },
      licenseClick() {
        if(!this.licenseCheckedDefault) {
          this.$trigger('click')
        }
      },
      submitOrder() {
        this.$trigger('submit')
      },
      submitScrambleOrder(e){
        this.$trigger('submit',e.detail)
      },
      changeDetail() {
        this.triggerEvent('changeDetail')
      },
      closeDetail() {
        this.triggerEvent('closeDetail')
      },
    },
  })
</script>
<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .custom-class
    align-items normal !important
  .footer-content
    display flex
    flex-direction row
    align-items flex-start
    padding 8px 16px
    background-image linear-gradient(270deg, #ffffff 0%, #edf4ff 100%)
    .change-tip
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      line-height 14px
      letter-spacing 0px
      color #999999
    .text-color
      color $train-color-999
    .url-color 
      color #FF6400
  .scramble-footer
    background-image linear-gradient(270deg, #FEFEFE -7%, #FEF7EF 99%)
  .card-button
    font-size 16px
    font-weight bold
    text-align center
    color white
    border-width 0px
    border-radius 8px
    background-color $train-color-theme-orange
    font-family PingFangSC-Regular
    font-weight 400
  .protocol
    font-size 12px
    display inline
    color #666666
    &.text
      color $train-color-999
    &.url
      color $train-color-333
      text-overflow ellipsis
  .scramble-text
    color #999
  .scramble-url
    color #333
</style>
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'pay-bottom-bar': '@/pages/order/components/order-detail-pay-bottom-bar',
    },
  }
</script>